import React from 'react';
import { motion } from 'framer-motion';
import './UpcomingEvents.css';

import codecode from '../assets/upcoming_events/code.jpg';
import cozmoclench from '../assets/upcoming_events/coz.jpg';
import meshmerize from '../assets/upcoming_events/mesh.jpg';
import olympiad from '../assets/upcoming_events/oly.jpg';

const eventsData = [
    {
        title: 'CODECODE',
        date: 'October 11, 2025',
        time: '10:00 AM',
        venue: 'IT Complex, PCE Nagpur',
        link: 'https://techfest.org/',
      //  description: 'Unleash your creativity! 🎨 It\'s time to showcase your design skills. Join the "Poster Competition" and present your unique ideas to everyone. Exciting prizes await the winners.',
        image: codecode,
    },
    {
        title: 'COZMOCLENCH',
        date: 'October 11, 2025',
        time: '10:00 AM',
        venue: 'IT Complex, PCE Nagpur',
        link: 'https://techfest.org/',
        image: cozmoclench,
    },     
    {
        title: 'MESHMERIZE',
        date: 'October 11, 2025',
        time: '10:00 AM',
        venue: 'IT Complex, PCE Nagpur',
        link: 'https://techfest.org/',
        image: meshmerize,
    },
    {
        title: 'TECHFEST OLYMPIAD',
        date: 'October 11, 2025',
        time: '10:00 AM',
        venue: 'IT Complex, PCE Nagpur',
        link: 'https://techfest.org/',
        image: olympiad,
    }
];

const UpcomingEvents = () => {
    return (
        <section className="upcoming-events-section">
            <h2 className="upcoming-events-title">
                Our Upcoming <span>Events...</span>
            </h2>
            <div className="events-carousel">
                {eventsData.map((event, index) => (
                    <motion.div 
                        className="upcoming-event-card" 
                        key={index}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: index * 0.2 }}
                        whileHover={{ scale: 1.05 }}
                    >
                        <img src={event.image} alt={event.title} className="upcoming-event-image" />
                        <div className="upcoming-event-details">
                            <h3>{event.title}</h3>
                            <p className="event-info"><strong>Date:</strong> {event.date}</p>
                            <p className="event-info"><strong>Time:</strong> {event.time}</p>
                            <p className="event-info"><strong>Venue:</strong> {event.venue}</p>
                            {event.link && <a href={event.link} target="_blank" rel="noopener noreferrer" className="register-link">Register Here</a>}
                            <p className="event-description-small">{event.description}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default UpcomingEvents;
